import { useCallback } from 'react';

import { UserCommunication } from '@this+that/models';

import {
  useDeleteCommunications,
  useRemoveUserCommunication,
} from '../UserCommunications';
import { DELETE_TOAST_KEYS } from '../UserCommunications/draft/useDeleteCommunications';

interface UseDeleteSelectionShortcutProps {
  filteredCommunications: UserCommunication[];
  selectedItems: Set<string>;
  selectedEmailIndex: number;
  clearSelection?: () => void;
}

export function useDeleteSelectionShortcut({
  filteredCommunications,
  selectedItems,
  selectedEmailIndex,
  clearSelection,
}: UseDeleteSelectionShortcutProps) {
  const { handleRemoveUserCommunication } = useRemoveUserCommunication();
  const deleteCommunications = useDeleteCommunications();

  return useCallback(() => {
    const focusedEmail = filteredCommunications[selectedEmailIndex];
    const messageIds =
      selectedItems.size > 0
        ? Array.from(selectedItems)
        : focusedEmail
          ? [focusedEmail.messageId]
          : [];
    if (messageIds.length === 0) {
      return;
    }
    const isBulk = selectedItems.size > 0;

    void deleteCommunications({
      messageIds,
      communications: filteredCommunications,
      deleteOthers: (ids) => {
        if (isBulk) {
          clearSelection?.();
        }
        return handleRemoveUserCommunication(ids);
      },
      othersToast: isBulk ? DELETE_TOAST_KEYS : undefined,
      onCleared: isBulk ? clearSelection : undefined,
    });
  }, [
    filteredCommunications,
    selectedItems,
    selectedEmailIndex,
    clearSelection,
    deleteCommunications,
    handleRemoveUserCommunication,
  ]);
}
